export default __webpack_public_path__ + "static/media/icon-https.42f84b9c76bd92dccbe7f83c76ee4172.svg";